const getOSInfo = () => {
  const ua = navigator.userAgent
  const matchs = ua.match(/(iPhone|iPad|iPod)/)
  if (matchs) {
    var name = matchs[1]
    if (ua.match(/OS ([\d_.]+) like Mac OS X/)) {
      return {
        name: name,
        isIPhone: name ==='iPhone'|| name === 'iPod',
        isIPad: name === 'iPad',
        isIOS: true,
        version: matchs[1].split('_').join('.')
      }
    }
  }
  return {
    name: 'unknown',
    version: '0.0.0'
  }
}
/**
 * Created by smart on 2018/10/19.
 * Email:chengshuai.tj@gmail.com
 * Author:Smart
 * Description: 修复ios设备上，秀米链接不滚动的bug
 */
export const iosXiumiHack = (warpper, webIframe) => {
  // 只有ios设备出现问题
  if (!getOSInfo().isIPhone) return
  webIframe.onload = _ => {
    warpper.style.overflow = 'hidden'
    setTimeout(_ => {
      warpper.style.overflow = 'auto'
    }, 1300)
    setTimeout(_ => {
      warpper.style.overflow = 'scroll'
    }, 1999)
    setTimeout(_ => {
      warpper.style.overflow = 'auto'
    }, 2000)
    setTimeout(_ => {
      warpper.style.overflow = 'scroll'
    }, 3999)
    setTimeout(_ => {
      warpper.style.overflow = 'auto'
    }, 3000)
    setTimeout(_ => {
      warpper.style.overflow = 'scroll'
    }, 5999)
    setTimeout(_ => {
      warpper.style.overflow = 'auto'
    }, 6000)
  }
}
